import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Instagram, Twitter } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { imgUrl } from '../lib/utils';
import theme from '../theme.config';
const SITE_LOGO = theme.assets.logo;

export const Footer = () => {
  const { store, isReseller } = useStore();
  const storeName = isReseller ? store?.store_name || 'Store' : theme.brand.name;
  const logoSrc = isReseller && store?.logo_url ? imgUrl(store.logo_url) : SITE_LOGO;

  return (
    <footer
      className="mt-auto"
      style={{
        background: 'hsl(20deg 40% 3%)',
        borderTop: '1px solid hsl(var(--primary) / 0.15)',
        boxShadow: '0 -1px 0 0 hsl(var(--primary) / 0.08)',
      }}
    >
      {/* Top lotus divider */}
      <div className="flex items-center gap-4 px-8 pt-8 pb-0 max-w-7xl mx-auto">
        <div className="flex-1 h-px" style={{ background: 'linear-gradient(to right, transparent, hsl(var(--primary) / 0.25))' }} />
        <span className="text-primary/50 text-sm">✦</span>
        <div className="flex-1 h-px" style={{ background: 'linear-gradient(to left, transparent, hsl(var(--primary) / 0.25))' }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={logoSrc} alt={storeName} className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm max-w-md leading-relaxed" style={{ fontFamily: "'Lora', serif" }}>
              {theme.copy.footer.tagline}
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 rounded-sm border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-sm border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-sm border border-border flex items-center justify-center text-muted-foreground hover:text-secondary hover:border-secondary/50 transition-all">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs text-primary uppercase tracking-widest mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
              ✦ Layanan
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-muted-foreground hover:text-primary text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Top Up Game</Link></li>
              <li><Link to="/" className="text-muted-foreground hover:text-primary text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Voucher Digital</Link></li>
              <li><Link to="/track" className="text-muted-foreground hover:text-primary text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Cek Transaksi</Link></li>
              <li><Link to="/reseller" className="text-muted-foreground hover:text-secondary text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Program Reseller</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs text-secondary uppercase tracking-widest mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
              ✦ Informasi
            </h4>
            <ul className="space-y-2">
              <li><Link to="/page/tentang-kami" className="text-muted-foreground hover:text-white text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Tentang Kami</Link></li>
              <li><Link to="/page/kebijakan-privasi" className="text-muted-foreground hover:text-white text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Kebijakan Privasi</Link></li>
              <li><Link to="/page/syarat-ketentuan" className="text-muted-foreground hover:text-white text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Syarat & Ketentuan</Link></li>
              <li><Link to="/page/hubungi-kami" className="text-muted-foreground hover:text-white text-sm transition-colors" style={{ fontFamily: "'Lora', serif" }}>Hubungi Kami</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderTop: '1px solid hsl(var(--border))' }}>
          <p className="text-muted-foreground text-xs" style={{ fontFamily: "'Space Mono', monospace" }}>
            © 2026 {isReseller ? storeName : theme.brand.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="text-primary/60 animate-gold-pulse text-xs" style={{ fontFamily: "'Space Mono', monospace" }}>✦</span>
            <span className="text-xs text-primary/60 tracking-widest uppercase" style={{ fontFamily: "'Space Mono', monospace" }}>
              CANDI AKTIF
            </span>
            <span className="text-primary/60 animate-gold-pulse text-xs" style={{ fontFamily: "'Space Mono', monospace" }}>✦</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
